
  import {defineComponent} from "vue";
  import router from "@/router";
  import {NamedRouting} from "@/domain/utils/NamedRouting";

  export default defineComponent({
    name: 'header-component',
    methods: {
      moveToPreviousPage(): void {
        router.back();
      },
      moveToSearchPage(): void {
        router.push(new NamedRouting('SearchView'));
      },
    }
  });
